import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NavInformationComponent } from '@components/master-layout/navs/components/nav-information/nav-information.component';
import { NavProfileComponent } from '@components/master-layout/navs/components/nav-profile/nav-profile.component';
import { AuthenService } from '@core/authen/authen.service';
import { ReportingPopupService } from '@core/services/reporting-popup.service';
import { SessionService } from '@core/session.service';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { matPerson } from '@ng-icons/material-icons/baseline';
import { matLogoutOutline } from '@ng-icons/material-icons/outline';
import { TranslateModule } from '@ngx-translate/core';
import { DefaultAvatarDirective } from '@shared/directives/default-avatar.directive';
import { LanguagePathDirective } from '@shared/directives/language-path.directive';
import { RequireLoginDirective } from '@shared/directives/require-login.directive';
import { UnsavedFormCheckDirective } from '@shared/directives/unsaved-form-check.directive';

@Component({
  selector: 'app-nav-custom-link-profile',
  templateUrl: './nav-custom-link-profile.component.html',
  imports: [
    NgIcon,
    LanguagePathDirective,
    UnsavedFormCheckDirective,
    CommonModule,
    RequireLoginDirective,
    DefaultAvatarDirective,
    TranslateModule,
    NavInformationComponent,
    NgbTooltipModule,
  ],
  viewProviders: [provideIcons({ matLogoutOutline, matPerson })],
})
export class NavCustomLinkProfileComponent
  extends NavProfileComponent
  implements OnInit
{
  @Input() about_link: string;

  constructor(
    authenService: AuthenService,
    reportingPopupService: ReportingPopupService,
    sessionService: SessionService
  ) {
    super(authenService, reportingPopupService, sessionService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
